// Single image uploader
import React, { useState, useCallback, useEffect } from 'react';
import { Box, Typography, Stack, IconButton, Tooltip, SvgIcon } from '@mui/material';
import ClearIcon from 'src/icons/untitled-ui/free/x-clear';
import { FileDropzone } from './only-dropzone'; // Assuming this is a custom component
import ZoomImage from 'src/components/zoom-image';

const SingleImageUploader = ({ formik, label = 'Chọn một hình để tài lên' }) => {
  const [image, setImage] = useState(null); // To store the uploaded file
  const [preview, setPreview] = useState(null); // To store the image preview (file or URL)
  const [errorMsg, setErrorMsg] = useState(null);

  // Load the default image from the URL when the component mounts
  useEffect(() => {
    if (formik.values.defaultImg) {
      const defaultImageUrl = formik.values.defaultImg.name;
      setPreview(defaultImageUrl);
      setImage(defaultImageUrl);
    }
  }, [formik.values.defaultImg]);

  useEffect(() => {
    if (!formik.isSubmitting) {
      // if(formik.values.image){
      //   setErrorMsg(null);
      // }
      if (formik.errors.image) {
        setErrorMsg(formik.errors.image);
      } else {
        setErrorMsg(null);
      }
    }
  }, [formik.isSubmitting, formik.values.image]);

  // Handle image drop and update formik's image field
  const handleImageDrop = useCallback(
    async ([file]) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result); // Set image preview to the dropped file
        setImage(file); // Set the uploaded file to state
        formik.setFieldValue('image', file); // Update formik's image field with the file
      };
      reader.readAsDataURL(file);
    },
    [formik],
  );

  // Handle image removal
  const handleImageRemove = () => {
    setPreview(null);
    setImage(null);
    formik.setFieldValue('image', null);
  };

  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="center" height="auto">
        <FileDropzone
          //sx={{ width: '400px' }} // Set a specific width
          accept={{ 'image/*': [] }}
          maxFiles={1} // Only allow one image to be selected
          onDrop={handleImageDrop}
          caption="(SVG, JPG, PNG, or GIF)"
          files={image ? [image] : []} // Pass the uploaded file to the FileDropzone
        />
      </Box>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          height: 192,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {preview ? (
          <>   
            <ZoomImage 
              thumbSrc={preview} zoomSrc={preview} alt="Zoomed Preview" height="172"
              />
            <Tooltip title="Xóa">
              <IconButton
                edge="end"
                sx={{
                  position: 'absolute',
                  top: 4,
                  right: 16,
                  bgcolor: 'white',
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent zoom open when deleting
                  handleImageRemove(); // Call the remove function
                }}
              >
                <SvgIcon>
                  <ClearIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </>
        ) : errorMsg ? (
          <Typography align="center" color="error" variant="contained">
            {errorMsg}
          </Typography>
        ) : (
          <Typography align="center" color="text.secondary" variant="contained">
            {label}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export default SingleImageUploader;
